import React from "react"
import api from "src/api"
import { buildSearchFilter } from "src/utils/build-search-filter"

const SEARCH_FIELDS = ["id", "name", "slug"]

export function useGetData() {
  const [dataItems, setDataItems] = React.useState([])
  const [dataItemsColumns, setDataItemsColumns] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)
  const [appliedFilters, setAppliedFilters] = React.useState("")

  React.useEffect(() => {
    getItems()
  }, [])

  const getItems = (page = 1, countOnPage = 20, filters = "") => {
    setIsLoading(true)
    api
      .get(`permissions?page=${page}&countOnPage=${countOnPage}${filters}`, {
        useV2Api: true,
      })
      .then(({ data }) => {
        setPagination({
          current: data.pagination.currentPage,
          pageSize: data.pagination.countOnPage,
          total: data.pagination.total,
        })
        setDataItems(data.items)
        setDataItemsColumns(
          data.items.map((item) => ({
            ...item,
            key: item.id,
          }))
        )
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  function handleTableChange(pagination) {
    getItems(pagination.current, pagination.pageSize, appliedFilters)
  }

  function handleSearchTable(value) {
    const filters = buildSearchFilter(value, SEARCH_FIELDS)
    setAppliedFilters(filters)
    getItems(1, 20, filters)
  }

  return {
    dataItems,
    dataItemsColumns,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    refetch: () => getItems(pagination?.current || 1, pagination?.pageSize || 20, appliedFilters),
  }
}
